import api from '@/api/api'
import { Notification } from 'element-ui'

const state = {
	contents: [],
}

const getters = {
	getContents: state => state.contents,
}

const mutations = {
	ADD_CONTENT (state, content) {
		state.contents.push(content)
	},
	async SAVE_CONTENT (state, content) {
		state.contents.push(content)
	},
	EMPTY_CONTENTS (state) {
		state.contents = []
	},
	async REMOVE_CONTENT (state, content) {

		let response

		await api.deleteContents(content)
		.then((res) => {
			response = res
			console.log('err', response)
		})
		.catch((err) => {
			response = err.data
			console.log('err', response)
		})
		
		for (let item of state.contents) {
			if (item.id == content) {        
				let index = state.contents.indexOf(item)
				state.contents.splice(index, 1)
			}
		}
	},
	async UPDATE_CONTENT (state, content) {
		let index
		for (let item of state.contents) {
			if (item.id == content.id) {
				index = state.contents.indexOf(item)
			}
		}
		state.contents[index] = content	
	},

	// Content Images
	// 
	async SAVE_CONTENT_IMAGES (state, content) {
		state.contents.push(content)
	},
	async REMOVE_CONTENT_IMAGES (state, content) {

		let response

		await api.deleteContents(content)
		.then((res) => {
			response = res
			console.log('err', response)
		})
		.catch((err) => {
			response = err.data
			console.log('err', response)
		})
		
		for (let item of state.contents) {
			if (item.id == content) {        
				let index = state.contents.indexOf(item)
				state.contents.splice(index, 1)
			}
		}
	},
}

const actions = {
	async newContent ({commit}, content) {

		let response
		await api.saveContents(content)
		.then((res) => {
			response = res
		})
		.catch((err) => {
			response = err.data
			console.log('err', response)
		})

		if (response.status == 201) {
			commit('SAVE_CONTENT', response.data.data)

		Notification.success({
			title: 'Success',
			message: 'Content has been successfully added.'
		})
		return 'success'

		} else if (response.type === 'validation_error') {			
			return response.fields
		}   
	},

	async fetchContents ({ commit }) {
		let dist = await api.fetchContents()
		dist = dist.data.data
		commit('EMPTY_CONTENTS')
		dist.forEach(function (elem) { commit('ADD_CONTENT', elem) })
	},

	async removeContent ({commit}, content) {
		commit('REMOVE_CONTENT', content)
	},
	async updateContent ({commit}, content) {
		let response
		await api.updateContents(content.id, content)
		.then((res) => {
			response = res
		})
		.catch((err) => {
			response = err.data
		})
		if (response.status === 200) {
			commit('UPDATE_CONTENT', content)
			Notification.success({
				title: 'Success',
				message: 'Content has been successfully updated.'
			})
			return 'success'
		} else if (response.type === 'validation_error') {			
			return response.fields
		}
	}
}

export default {
state,
getters,
mutations,
actions
}



// WEBPACK FOOTER //
// ./src/store/modules/contents.js